import cx from 'classnames';
import { ChangeEventHandler, forwardRef, InputHTMLAttributes, MouseEventHandler } from 'react';

import style from './InputRadio.module.css';

export type Props = {
    label: string;
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLLabelElement>;
    inputProps: InputHTMLAttributes<HTMLInputElement> & {
        onChange?: ChangeEventHandler<HTMLInputElement>;
        'data-testid'?: string;
    };
    className?: string;
};

export const InputRadio = forwardRef<HTMLInputElement, Props>(
    ({ label, disabled = false, onClick, inputProps, className }, ref) => {
        return (
            <div className={cx(style.wrapper, className)}>
                <label onClick={onClick} className={cx(style.label, 'font-xs-regular')}>
                    <input
                        {...inputProps}
                        type="radio"
                        ref={ref}
                        className={cx(style.input)}
                        disabled={disabled}
                    />
                    {label}
                </label>
            </div>
        );
    },
);
